var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-10"},[_c('p',{staticClass:"bold text-h5"},[_vm._v("404")]),_c('h2',{staticClass:"text-h4 text"},[_vm._v(" Niet gevonden ")])])
}]

export { render, staticRenderFns }